import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../services/base.service';
import { PopupService } from '../../services/popup.service';
import { MapService } from '../../services/map.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/Subscription';
import { BrandingService } from '../../services/branding.service';
import { UserService } from '../../services/user.service';
import { FeatureService } from '../../services/feature.service';

@Component({
  selector: 'app-marqetmap-app',
  templateUrl: './marqetmap-app.component.html',
  styleUrls: ['./marqetmap-app.component.less']
})
export class MarqetmapAppComponent implements OnInit {

  routerEventsSubscription: Subscription;
  routeParamsSubscription: Subscription;
  linkedInFeatureSubscription: Subscription;
  mapLoadedSubscription: any;
  isIntegratedMapsActive: boolean = false;

  constructor(public popupService: PopupService, public baseService: BaseService,
    public router: Router, public mapService: MapService, public activatedRoute: ActivatedRoute,
    public brandingService: BrandingService, public userService: UserService, public featureService: FeatureService) { }

  ngOnInit() {
    
    this.brandingService.addJllSiteBrandingFavicon();
  	this.baseService.checkIfMapLoaded();
    this.onRouteChange();
    this.checkToTogglePopup();
  }

  ngAfterViewInit() {
    let w = (<any>window);
    w.Events.subscribe('goToMap',()=> {
      this.mapService.mapResizeInterval && clearInterval(this.mapService.mapResizeInterval);
      w.domBody.classList.remove('search-home');
      w.google && w.google.maps && w.map && w.google.maps.event.trigger(w.map, 'resize');
      this.router.navigate(['/map'], {
        queryParamsHandling: 'merge'
      });
    });

    this.linkedInFeatureSubscription = this.userService.linkedInFeatureStream.subscribe((value)=>{
      if(value && this.featureService.featureToExecute) {
        this.featureService.executeFeature();
      }
    });

    w.Events.subscribe('redirectToMapRoute', ()=> {
      if(!this.router.isActive('/map', false)) {
        w.Events.publish('goToMap');
      }
    });

    this.mapLoadedSubscription = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
        this.isIntegratedMapsActive = (<any>window).mmap.isIntegratedMapsActive();
      }
      (<any>window).Events.publish('detectChanges');
    });
  }

  onRouteChange() {
    this.routerEventsSubscription = this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        this.checkToTogglePopup();
      }
    });
  }

  checkToTogglePopup() {
    this.routeParamsSubscription = this.activatedRoute.params.subscribe(params => {
      this.baseService.paramChangeSource.next(true);
      if(this.activatedRoute.firstChild) {
        this.popupService.togglePopup(this.activatedRoute.firstChild && this.activatedRoute.firstChild.snapshot.paramMap.get('popup'), 
                                    this.activatedRoute.firstChild && this.activatedRoute.firstChild.firstChild && this.activatedRoute.firstChild.firstChild.snapshot.paramMap.get('inner'), this.activatedRoute.firstChild && this.activatedRoute.firstChild.firstChild && this.activatedRoute.firstChild.firstChild.firstChild && this.activatedRoute.firstChild.firstChild.firstChild.snapshot.paramMap.get('subInner'));
      } else {
        this.popupService.togglePopup();
      }
    });
  }

  ngOnDestroy() {
    this.routeParamsSubscription && this.routeParamsSubscription.unsubscribe();
    this.routerEventsSubscription && this.routerEventsSubscription.unsubscribe();
    this.linkedInFeatureSubscription && this.linkedInFeatureSubscription.unsubscribe();
  }

  notificationOptions = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxStack: 7,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    animate: 'fromLeft',
    position: ['left', 'bottom']
	}

  mapsSearchOptions = {
    API_URL: environment.APP.API_URL,
    placeholder: 'Address, Neighborhood, City, or Zip'
  }

}



// WEBPACK FOOTER //
// ./src/app/components/marqetmap-app/marqetmap-app.component.ts